import { customAlphabet } from 'nanoid';

const traceIdGenerator = customAlphabet('1234567890abcdef', 10);

export function getTraceId(serviceName = '') {
  return `web:${serviceName}:${traceIdGenerator()}`;
}
